import { Divider, Flex, Form, Switch, Text } from "@/atoms"
import { isGitHubIssuesPermissionMissing } from "@/domain/integration"
import { useTranslation } from "@/hooks/useTranslation"
import { TicketingNotificationFields } from "@/pages/IntegrationsPage/components/organisms/TicketingConfigurationTab"
import {
  GITHUB_ISSUES_NOTIFICATIONS_KEY_PREFIX,
  GITHUB_KEY_PREFIX
} from "./GitHubConfigurationPage.constants"
import { GitHubIssuesPermissionStatus } from "./GitHubIssuesPermissionStatus"

import styles from "./GitHubIssuesSettings.module.scss"

import type { GitHubIssuesSettingsProps } from "./GitHubConfigurationPage.types"

export const GitHubIssuesSettings = (props: GitHubIssuesSettingsProps) => {
  const { form, issuesEnabled, issuesPermission, installationUrl } = props
  const { t } = useTranslation("translation", { keyPrefix: GITHUB_KEY_PREFIX })
  const watchedEnabled: boolean | undefined = Form.useWatch(
    "issuesEnabled",
    form
  )
  const isPermissionMissing = isGitHubIssuesPermissionMissing(issuesPermission)
  const isEnabled = !isPermissionMissing && (watchedEnabled ?? issuesEnabled)

  return (
    <Flex vertical gap={16} className={styles.settings}>
      <Divider className={styles.divider} />
      <Flex justify="space-between" align="center" gap={16}>
        <Flex vertical>
          <Text strong>{t("issues.title")}</Text>
          <Text type="secondary">{t("issues.description")}</Text>
        </Flex>
        <Flex gap={8} align="center">
          <Text>{t("issues.enable")}</Text>
          {isPermissionMissing ? (
            // off without the permission; the form keeps the stored value to save it
            <Switch
              size="small"
              checked={false}
              disabled
              aria-label={t("issues.enable")}
            />
          ) : (
            <Form.Item name="issuesEnabled" valuePropName="checked" noStyle>
              <Switch size="small" aria-label={t("issues.enable")} />
            </Form.Item>
          )}
        </Flex>
      </Flex>
      <GitHubIssuesPermissionStatus
        permission={issuesPermission}
        installationUrl={installationUrl}
      />
      {isEnabled && (
        <TicketingNotificationFields
          keyPrefix={GITHUB_ISSUES_NOTIFICATIONS_KEY_PREFIX}
          vendorName={t("issues.title")}
        />
      )}
    </Flex>
  )
}
